import getResponseJson from './getresponsejson';

export const commentService = serviceRoutes => {
  const addComment = (
    commentSourceType,
    commentSourceId, // patientId or encounterId
    commentText
  ) => {
    return fetch(serviceRoutes.addComment, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        commentText,
        commentSourceType,
        commentSourceId
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const saveComment = comment => {
    return fetch(serviceRoutes.addComment, {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(comment)
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const deleteComment = commentId => {
    return fetch(serviceRoutes.addComment, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: commentId })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  }

  const setCommentInActive = comment => {
    return fetch(serviceRoutes.addComment, {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(comment)
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  }

  const addCommentToPatient = (
    patientId,
    commentText
  ) => addComment(
    'Patient',
    patientId,
    commentText
  );

  const addCommentToEncounter = (
    encounterId,
    commentText
  ) => addComment(
    'CoreEncounter',
    encounterId,
    commentText
  );

  return {
    addComment,
    addCommentToPatient,
    addCommentToEncounter,
    deleteComment,
    saveComment,
    setCommentInActive
  };
};

export default commentService;
